import { MosError } from 'src/utils/errors/MosError';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import type { UsersWithSessionsResponse } from 'src/types/session';

interface GetUsersWithActiveSessionsParams {
  tenantId?: string;
  limit?: number;
  cursor?: string;
}

const getUsersWithActiveSessions = async (
  params?: GetUsersWithActiveSessionsParams,
): Promise<UsersWithSessionsResponse> => {
  const authTokenHttp = await getCompatibleAuthTokenHttp();

  const queryParams = new URLSearchParams();
  if (params?.tenantId) {
    queryParams.append('tenantId', params.tenantId);
  }
  if (params?.limit) {
    queryParams.append('limit', String(params.limit));
  }
  if (params?.cursor) {
    queryParams.append('cursor', params.cursor);
  }

  const queryString = queryParams.toString();
  let url: string = '/shared/admin/sessions/users';
  if (queryString) {
    url += `?${queryString}`;
  }

  const response = await authTokenHttp<UsersWithSessionsResponse>(url, {
    method: 'GET',
  });

  if (response.data) {
    return response.data;
  }

  throw new MosError({
    error: 'Failed to fetch users with active sessions',
    statusCode: response.status,
  });
};

export default getUsersWithActiveSessions;
